import React from 'react';

import './components/css/hd.css';
import './components/css/hd_add.css';
import './components/css/social.css';
import './components/css/scrollbars.css';
import './components/css/chats.css';
import './components/css/penta.css';
import './components/css/group.css';

import { SocialProvider } from './contexts/socialContext';
import { StateProvider } from './contexts/stateContext';

import { RoutesMain } from './components/RoutesMain';
import { LangProvider } from './contexts/langContext';
import { CelebsProvider } from './contexts/celebsContext';
import { ChatStateProvider } from './contexts/chatStateContext';
import { AstroSprite } from './components/UiKit/AstroIcon';

function App() {
  return (
    <SocialProvider>
      <StateProvider>
        <LangProvider>
          <CelebsProvider>
            <ChatStateProvider>
              <AstroSprite />
              <RoutesMain />
            </ChatStateProvider>
          </CelebsProvider>
        </LangProvider>
      </StateProvider>
    </SocialProvider>
  );
}

export default App;